<template>
  <div class="container">
    <div class="popup-div">
      <div class="popup-title">
        您好，您还没有获得额度！<br /><span>请先完成额度评估，再继续参加活动哦~</span>
      </div>
      <div v-if="false" class="popup-content">
        {{
          this.couponType === '2'
            ? '请至APP——【我的】——【我的邀请奖励】申请提现'
            : '请至APP—【我的】—【优惠券】查看'
        }}
      </div>
      <div class="popup-butn" @click="butnClick">
        立即申请额度
      </div>
    </div>
    <div class="popup-close" @click="close">
      <img src="../../../assets/img/common/close-c.png" />
    </div>
  </div>
</template>

<script>
import * as global from '../../../utils/active.js'
import LoanUrl from '@/mixins/loanurl'
export default {
    'mixins': [LoanUrl],
    'methods': {
        close () {
            this.$sourceDialog.close()
        },
        butnClick () {
            if (window.PPDWebUI.os.inApp) {
                this.onLoanClick()
            } else {
                if (global.isWeixin()) {
                    const path =
                        'https://mktop.ppdai.com/mktop/advertising_page?activityurl=https://t.ppdai.com/B0yag'
                    window.location.href = path
                } else {
                    const path = 'https://t.ppdai.com/B0yag'
                    window.location.href = path
                }
            }
        }
    }
}
</script>

<style lang="less" scoped>
@import '../../../assets/less/common.less';
.container {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background-color: rgba(0, 0, 0, 0.8);
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    z-index: 999;

    .popup-div {
        width: 280px;
        height: 180px;
        background: rgba(255, 255, 255, 1);
        border-radius: 4px;
        text-align: center;

        .popup-title {
            .f-16-bold();
            color: #384369;
            margin-top: 55px;
            span{
                .f-13-bold();
            }
        }

        .popup-content {
            .f-14();
            color: #384369;
            margin-top: 15px;
            width: 100%;
            padding-left: 19px;
            padding-right: 19px;
        }

        .popup-butn {
            .f-16();
            width: 180px;
            height: 36px;
            background: rgba(93, 128, 237, 1);
            border-radius: 18px;
            margin: auto;
            margin-top: 30px;
            width: 180px;
            height: 36px;
            color: #ffffff;
            border-radius: 18px;
            text-align: center;
            line-height: 36px;
        }
    }
    .popup-close {
        height: 32px;
        width: 32px;
        padding: 16px 0;
        img {
            width: 26px;

            margin: 0 auto;
            height: 26px;
        }
    }
}
</style>
